import { useSessionContext } from '@users/session/SessionContext';

export const useIsGuest = () => {
  const { currentUser } = useSessionContext();
  return !currentUser?.id;
};
